<template>
    <div v-bind="$attrs">
        <i :class="value.icon" v-if="value.icon" />
        <span v-if="myLabel">{{ value.i18n ? $i18n.t(myLabel) : myLabel }}</span>
        <component :is="myComponent" v-if="myComponent" :data="value" />
    </div>
</template>
<script>
export default {
    name: "Title",
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            myLabel: undefined,
            myComponent: undefined
        };
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.update();
            }
        },
        "$i18n.locale"() {
            this.update();
        }
    },
    methods: {
        isComponent(input = {}) {
            return !!input.render || !!input.template;
        },
        update() {
            let { title: result = "--" } = this.value || {};
            if ("function" === typeof result) {
                result = result();
            }
            if (this.isComponent(result)) {
                this.myComponent = result;
            } else {
                this.myLabel = result;
            }
        }
    }
};
</script>
